module.exports = __webpack_public_path__ + "static/media/bars-center-neon.f645d8cd.svg";